(() => {
  'use strict';

  if (window.nfFrameMaterialCategories) return;

  const text = value => String(value || '').trim();
  const normalise = value => text(value).toLocaleLowerCase('da-DK');
  const idOf = material => text(material?.id);
  const nameOf = material => text(material?.navn || material?.name || idOf(material));
  const familyIdOf = material => text(material?.familie || material?.familyId || 'andet');
  const familyNameOf = material => text(material?.familieNavn || material?.familyName || familyIdOf(material));

  function group(materials) {
    const groups = new Map();
    (Array.isArray(materials) ? materials : []).forEach(material => {
      const id = familyIdOf(material);
      if (!groups.has(id)) groups.set(id, { id, name: familyNameOf(material), materials: [] });
      groups.get(id).materials.push(material);
    });
    return [...groups.values()];
  }

  function search(materials, query) {
    const needle = normalise(query);
    if (!needle) return [...(Array.isArray(materials) ? materials : [])];
    return materials.filter(material => normalise([
      nameOf(material), familyNameOf(material), familyIdOf(material), idOf(material)
    ].join(' ')).includes(needle));
  }

  window.nfFrameMaterialCategories = Object.freeze({
    group,
    search,
    idOf,
    nameOf,
    familyIdOf,
    familyNameOf
  });
})();
